import { useEffect, useState, useCallback } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

const containerStyle = {
  width: '100%',
  height: '400px',
  borderRadius: '0.5rem'
};

// Evolutions Medspa coordinates (9911 Kennerly Road, Suite C, 63128)
const center = {
  lat: 38.5079,
  lng: -90.3793
};

const Map = () => {
  const [apiKey, setApiKey] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchApiKey = async () => {
      try {
        const { data, error } = await supabase.functions.invoke('get-google-maps-key');
        
        if (error) {
          console.error('Error fetching Google Maps API key:', error);
          setError('Failed to load map configuration');
          toast.error('Failed to load map configuration');
          return;
        }
        
        if (!data?.GOOGLE_MAPS_API_KEY) {
          throw new Error('API key not found in response');
        }
        
        setApiKey(data.GOOGLE_MAPS_API_KEY);
      } catch (err) {
        console.error('Error in fetchApiKey:', err);
        setError('Failed to load map configuration');
        toast.error('Failed to load map configuration');
      } finally {
        setIsLoading(false);
      }
    };

    fetchApiKey();
  }, []);

  const onLoad = useCallback((map: google.maps.Map) => {
    const bounds = new window.google.maps.LatLngBounds(center);
    map.fitBounds(bounds);
    map.setZoom(16); // Increased zoom level for better visibility of the location
  }, []);

  if (isLoading) {
    return (
      <div className="h-[400px] bg-muted rounded-lg flex items-center justify-center">
        Loading map...
      </div>
    );
  }

  if (error || !apiKey) {
    return (
      <div className="h-[400px] bg-muted rounded-lg flex items-center justify-center text-center p-4">
        <p>Unable to load the map at this time. Please try again later.</p>
      </div>
    );
  }

  return (
    <div className="w-full h-[400px] rounded-lg overflow-hidden shadow-lg">
      <LoadScript googleMapsApiKey={apiKey}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={16}
          onLoad={onLoad}
        >
          <Marker
            position={center}
            title="Evolutions Medspa - 9911 Kennerly Road, Suite C"
          />
        </GoogleMap>
      </LoadScript>
    </div>
  );
};

export default Map;